export const startsWithLocale = (url: string): boolean => {
  const localeRegex =
    /^(en|fr|de|it|es|nl)-(gb|us|ca|vg|ie|fr|de|it|es|nl|at|be|ch|dk|pl|lu|fi|se|ro|pt|mt|li|lv|hu|gr|cz|cy|hr|bg)/i;

  return localeRegex.test(url);
};
